import { render, staticRenderFns } from "./MailSetting.vue?vue&type=template&id=26dd2524"
import script from "./MailSetting.vue?vue&type=script&lang=js"
export * from "./MailSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports